import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { OrderedMap } from 'immutable';
import articlesReducer from './entities/articles';
import categoriesReducer from './entities/categories';
import subcategoriesReducer from './entities/subcategories';
import { selectRootCategoriesOrder } from './rootCategoriesOrder';
import { getCountOfPublishedArticles, translate } from 'knowledge-content-ui/utils/categoryUtils';
import StateConstants from 'knowledge-content-ui/constants/StateConstants';
const getLocalState = state => state.organizeEntities;
const getCategoryOrganizationBuffer = state => state.categoryOrganizationBuffer;
const getCategoryOrganizationInfo = state => state.categoryOrganizationInfo;
export default combineReducers({
  articles: articlesReducer,
  categories: categoriesReducer,
  subcategories: subcategoriesReducer
});
export const selectArticles = state => getLocalState(state).articles;
export const selectCategories = state => getLocalState(state).categories;
export const selectSubcategories = state => getLocalState(state).subcategories;
export const selectOrganizePageLanguage = state => getCategoryOrganizationBuffer(state).requestedLanguage || getCategoryOrganizationInfo(state).requestedLanguage;
export const selectPrimaryLanguage = state => getCategoryOrganizationBuffer(state).primaryLanguage || getCategoryOrganizationInfo(state).primaryLanguage;
export const selectIsDisplayingLanguageVariant = createSelector([selectPrimaryLanguage, selectOrganizePageLanguage], (primaryLanguage, requestedLanguage) => !!requestedLanguage && requestedLanguage !== primaryLanguage);
const getArticles = (ids, articles, language) => OrderedMap(ids.map(id => [id, articles.get(id.toString()).setIn(['values', 'hs_language'], language)]));
const getSubcategories = (ids, subcategories, allArticles, requestedLanguage) => OrderedMap(ids.map(id => {
  const subcat = subcategories.get(id);
  const articles = getArticles(subcat.get('articles'), allArticles, requestedLanguage);
  const state = getCountOfPublishedArticles(articles) > 0 ? StateConstants.PUBLISHED : StateConstants.DRAFT;
  return [id, subcat.set('articles', articles).set('state', state)];
}));
const getCategoryWithChildren = (catId, categories, allSubcategories, allArticles, requestedLanguage, primaryLanguage) => {
  const category = categories.get(catId);
  const articles = getArticles(category.get('articles'), allArticles, requestedLanguage);
  const subcategories = getSubcategories(category.get('subcategories'), allSubcategories, allArticles, requestedLanguage);
  const state =
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'OrderedMap<unknown, unknown>' is... Remove this comment to see the full error message
  getCountOfPublishedArticles(articles, subcategories) > 0 ? StateConstants.PUBLISHED : StateConstants.DRAFT;
  return category.withMutations(cat => {
    translate({
      category: cat.merge({
        articles,
        subcategories,
        state
      }),
      requestedLanguage,
      primaryLanguage,
      isSubcategory: false
    });
  });
};
export const selectCategoryOrganizationTree = createSelector([selectArticles, selectCategories, selectSubcategories, selectRootCategoriesOrder, selectOrganizePageLanguage, selectPrimaryLanguage], (articles, categories, subcategories, rootCategoriesOrder, organizePageLanguage, primaryLanguage) => {
  const rootCategories = OrderedMap(rootCategoriesOrder.map(catId => [catId.toString(), getCategoryWithChildren(catId.toString(), categories, subcategories, articles, organizePageLanguage, primaryLanguage)]));
  return rootCategories;
});